import { Suspense, lazy } from 'react'

const createLazyRoute = (importFn: Parameters<typeof lazy>[0]) => {
  const Lazy = lazy(importFn)
  const LazyRenderer = (props: unknown[]) => (
    <Suspense fallback={null}>
      <Lazy {...props} />
    </Suspense>
  )
  return LazyRenderer
}

export const EmailSuggestionRoute = createLazyRoute(() => import('./EmailSuggestion'))
export const DashboardRoute = createLazyRoute(() => import('./Dashboard'))
export const DiscoverRoute = createLazyRoute(() => import('./Discover'))
export const MyCollegesRoute = createLazyRoute(() => import('./MyColleges'))
export const CareerRoute = createLazyRoute(() => import('./Discover/CareerDetails'))
export const CollegeRoute = createLazyRoute(() => import('./college'))
export const MessageCenterRoute = createLazyRoute(() => import('./message-center/MessageCenter'))
export const MyProfileRoute = createLazyRoute(() => import('./profile/MyProfile'))
export const SurveysRoute = createLazyRoute(() => import('./Surveys'))
export const RequiredActionsRoute = createLazyRoute(() => import('./RequiredActions'))
export const EventsRoute = createLazyRoute(() => import('./Events'))
export const CollegeCompareRoute = createLazyRoute(() => import('./CollegeCompare'))
export const LoginRoute = createLazyRoute(() => import('./Login'))
export const ConfirmCleverLinkRoute = createLazyRoute(() => import('./oauth/ConfirmCleverLink'))
export const ConfirmClassLinkLinkRoute = createLazyRoute(() => import('./oauth/ConfirmClassLinkLink'))
export const ConfirmGoogleLinkRoute = createLazyRoute(() => import('./oauth/ConfirmGoogleLink'))
export const ConfirmLinkRoute = createLazyRoute(() => import('./ConfirmLink/HighSchool'))
export const ConfirmGuidanceOrgLinkRoute = createLazyRoute(() => import('./ConfirmLink/GuidanceOrg'))
export const ChangePasswordRoute = createLazyRoute(() => import('./profile/ChangePassword'))
export const EmailVerifyRoute = createLazyRoute(() => import('./profile/EmailVerify'))
export const MobileDocCenterRoute = createLazyRoute(() => import('./CoalitionAppBuilder/MobileDocCenter'))
export const CoalitionAppBuilderRoute = createLazyRoute(() => import('./CoalitionAppBuilder'))
export const MobilePrinciplesYouRoute = createLazyRoute(
  () => import('./Career/MobileCareerAssessments/MobilePrinciplesYouCharacterAssessment'),
)
export const MobileONetInterestProfilerRoute = createLazyRoute(
  () => import('./Career/MobileCareerAssessments/MobileONetInterestProfiler'),
)

export const MobileFormDetailsRoute = createLazyRoute(() => import('./Dashboard/Assignments/Mobile/MobileFormDetails'))

export const CommonAppConfirmLinkRoute = createLazyRoute(() => import('routes/profile/ConfirmCommonApp'))
